import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=d8bc8efe"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8bc8efe')) {
      api.createRecord('d8bc8efe', component.options)
    } else {
      api.reload('d8bc8efe', component.options)
    }
    module.hot.accept("./Highlights.vue?vue&type=template&id=d8bc8efe", function () {
      api.rerender('d8bc8efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/Highlights.vue"
export default component.exports